// extracted by mini-css-extract-plugin
export default {"wrapper":"W_NotificationEmptyContainer_wrapper__0N+ap","text":"W_NotificationEmptyContainer_text__GpYl+","image":"W_NotificationEmptyContainer_image__xPJ6X"};